// extracted by mini-css-extract-plugin
export var addressFields = "_hw-0";
export var animationContainer = "_hw-1";
export var footer = "_hw-2";
export var lineItems = "_hw-3";
export var modalContent = "_hw-4";
export var orderName = "_hw-5";
export var strong = "_hw-6";
export var warning = "_hw-7";